
type RateObj = {
  amount: number;
  rate: number;
  range: { min: number; max: number };
  numberOfCards: number;
};

type MergedResult = { range: RateObj["range"]; amount: number };
export const mergeAndAccumulate = (arr: RateObj[]) => {
  const rangeMap: Map<string, MergedResult> = new Map();

  arr.forEach((item) => {
    const rangeString = JSON.stringify(item.range);
    const calculatedAmount = item.amount * item.numberOfCards;
    if (rangeMap.has(rangeString)) {
      rangeMap.get(rangeString)!.amount += calculatedAmount;
    } else {
      rangeMap.set(rangeString, {
        range: item.range,
        amount: calculatedAmount,
      });
    }
  });
return Array.from(rangeMap.values());
};